export default __webpack_public_path__ + "static/media/github.95ad9234.svg";